export const queryData = [
  {
    query: "select * from orders;",
    result: [
      {
        orderID: 10248,
        customerID: "VINET",
        employeeID: 5,
        orderDate: "1996-07-04",
        requiredDate: "1996-08-01",
        shippedDate: "1996-07-16",
        shipVia: 3,
        freight: 32.38,
        shipName: "Vins et alcools Chevalier",
        shipAddress: "59 rue de l'Abbaye",
        shipCity: "Reims",
        shipRegion: "NULL",
        shipPostalCode: 51100,
        shipCountry: "France",
      },
      {
        orderID: 10249,
        customerID: "TOMSP",
        employeeID: 6,
        orderDate: "1996-07-05",
        requiredDate: "1996-08-16",
        shippedDate: "1996-07-10",
        shipVia: 1,
        freight: 11.61,
        shipName: "Toms Spezialitäten",
        shipAddress: "Luisenstr. 48",
        shipCity: "Münster",
        shipRegion: "NULL",
        shipPostalCode: 44087,
        shipCountry: "Germany",
      },
      {
        orderID: 10250,
        customerID: "HANAR",
        employeeID: 4,
        orderDate: "1996-07-08",
        requiredDate: "1996-08-05",
        shippedDate: "1996-07-12",
        shipVia: 2,
        freight: 65.83,
        shipName: "Hanari Carnes",
        shipAddress: "Rua do Paço 67",
        shipCity: "Rio de Janeiro",
        shipRegion: "RJ",
        shipPostalCode: "05454-876",
        shipCountry: "Brazil",
      },
      {
        orderID: 10251,
        customerID: "VICTE",
        employeeID: 3,
        orderDate: "1996-07-08",
        requiredDate: "1996-08-05",
        shippedDate: "1996-07-15",
        shipVia: 1,
        freight: 41.34,
        shipName: "Victuailles en stock",
        shipAddress: "2 rue du Commerce",
        shipCity: "Lyon",
        shipRegion: "NULL",
        shipPostalCode: 69004,
        shipCountry: "France",
      },
      {
        orderID: 10252,
        customerID: "SUPRD",
        employeeID: 4,
        orderDate: "1996-07-09",
        requiredDate: "1996-08-06",
        shippedDate: "1996-07-11",
        shipVia: 2,
        freight: 51.3,
        shipName: "Suprêmes délices",
        shipAddress: "Boulevard Tirou 255",
        shipCity: "Charleroi",
        shipRegion: "NULL",
        shipPostalCode: "B-6000",
        shipCountry: "Belgium",
      },
      {
        orderID: 10253,
        customerID: "HANAR",
        employeeID: 3,
        orderDate: "1996-07-10",
        requiredDate: "1996-07-24",
        shippedDate: "1996-07-16",
        shipVia: 2,
        freight: 58.17,
        shipName: "Hanari Carnes",
        shipAddress: "Rua do Paço 67",
        shipCity: "Rio de Janeiro",
        shipRegion: "RJ",
        shipPostalCode: "05454-876",
        shipCountry: "Brazil",
      },
      {
        orderID: 10254,
        customerID: "CHOPS",
        employeeID: 5,
        orderDate: "1996-07-11",
        requiredDate: "1996-08-08",
        shippedDate: "1996-07-23",
        shipVia: 2,
        freight: 22.98,
        shipName: "Chop-suey Chinese",
        shipAddress: "Hauptstr. 31",
        shipCity: "Bern",
        shipRegion: "NULL",
        shipPostalCode: 3012,
        shipCountry: "Switzerland",
      },
    ],
  },

  {
    query: "select * from orders where employeeId = 3;",
    result: [
      {
        orderID: 10255,
        customerID: "RICSU",
        employeeID: 9,
        orderDate: "1996-07-12",
        requiredDate: "1996-08-09",
        shippedDate: "1996-07-15",
        shipVia: 3,
        freight: 148.33,
        shipName: "Richter Supermarkt",
        shipAddress: "Starenweg 5",
        shipCity: "Genève",
        shipRegion: "NULL",
        shipPostalCode: 1204,
        shipCountry: "Switzerland",
      },
      {
        orderID: 10256,
        customerID: "WELLI",
        employeeID: 3,
        orderDate: "1996-07-15",
        requiredDate: "1996-08-12",
        shippedDate: "1996-07-17",
        shipVia: 2,
        freight: 13.97,
        shipName: "Wellington Importadora",
        shipAddress: "Rua do Mercado 12",
        shipCity: "Resende",
        shipRegion: "SP",
        shipPostalCode: "08737-363",
        shipCountry: "Brazil",
      },
      {
        orderID: 10257,
        customerID: "HILAA",
        employeeID: 4,
        orderDate: "1996-07-16",
        requiredDate: "1996-08-13",
        shippedDate: "1996-07-22",
        shipVia: 3,
        freight: 81.91,
        shipName: "HILARION-Abastos",
        shipAddress: "Carrera 22 con Ave. Carlos Soublette #8-35",
        shipCity: "San Cristóbal",
        shipRegion: "Táchira",
        shipPostalCode: 5022,
        shipCountry: "Venezuela",
      },
      {
        orderID: 10258,
        customerID: "ERNSH",
        employeeID: 1,
        orderDate: "1996-07-17",
        requiredDate: "1996-08-14",
        shippedDate: "1996-07-23",
        shipVia: 1,
        freight: 140.51,
        shipName: "Ernst Handel",
        shipAddress: "Kirchgasse 6",
        shipCity: "Graz",
        shipRegion: "NULL",
        shipPostalCode: 8010,
        shipCountry: "Austria",
      },
      {
        orderID: 10259,
        customerID: "CENTC",
        employeeID: 4,
        orderDate: "1996-07-18",
        requiredDate: "1996-08-15",
        shippedDate: "1996-07-25",
        shipVia: 3,
        freight: 3.25,
        shipName: "Centro comercial Moctezuma",
        shipAddress: "Sierras de Granada 9993",
        shipCity: "México D.F.",
        shipRegion: "NULL",
        shipPostalCode: "05022",
        shipCountry: "Mexico",
      },
    ],
  },

  {
    query: "select * from orders where freight > 40;",
    result: [
      {
        orderID: 10260,
        customerID: "OTTIK",
        employeeID: 4,
        orderDate: "1996-07-19",
        requiredDate: "1996-08-16",
        shippedDate: "1996-07-29",
        shipVia: 1,
        freight: 55.09,
        shipName: "Ottilies Käseladen",
        shipAddress: "Mehrheimerstr. 369",
        shipCity: "Köln",
        shipRegion: "NULL",
        shipPostalCode: 50739,
        shipCountry: "Germany",
      },
      {
        orderID: 10261,
        customerID: "QUEDE",
        employeeID: 4,
        orderDate: "1996-07-19",
        requiredDate: "1996-08-16",
        shippedDate: "1996-07-30",
        shipVia: 2,
        freight: 3.05,
        shipName: "Que Delícia",
        shipAddress: "Rua da Panificadora 12",
        shipCity: "Rio de Janeiro",
        shipRegion: "RJ",
        shipPostalCode: "02389-673",
        shipCountry: "Brazil",
      },
      {
        orderID: 10262,
        customerID: "RATTC",
        employeeID: 8,
        orderDate: "1996-07-22",
        requiredDate: "1996-08-19",
        shippedDate: "1996-07-25",
        shipVia: 3,
        freight: 48.29,
        shipName: "Rattlesnake Canyon Grocery",
        shipAddress: "2817 Milton Dr.",
        shipCity: "Albuquerque",
        shipRegion: "NM",
        shipPostalCode: 87110,
        shipCountry: "USA",
      },
      {
        orderID: 10263,
        customerID: "ERNSH",
        employeeID: 9,
        orderDate: "1996-07-23",
        requiredDate: "1996-08-20",
        shippedDate: "1996-07-31",
        shipVia: 3,
        freight: 146.06,
        shipName: "Ernst Handel",
        shipAddress: "Kirchgasse 6",
        shipCity: "Graz",
        shipRegion: "NULL",
        shipPostalCode: 8010,
        shipCountry: "Austria",
      },
      {
        orderID: 10264,
        customerID: "FOLKO",
        employeeID: 6,
        orderDate: "1996-07-24",
        requiredDate: "1996-08-21",
        shippedDate: "1996-08-23",
        shipVia: 3,
        freight: 3.67,
        shipName: "Folk och fä HB",
        shipAddress: "Åkergatan 24",
        shipCity: "Bräcke",
        shipRegion: "NULL",
        shipPostalCode: "S-844 67",
        shipCountry: "Sweden",
      },
    ],
  },

  {
    query: "select * from orders where orderedDate = '1996-07-10';",
    result: [
      {
        orderID: 10265,
        customerID: "BLONP",
        employeeID: 2,
        orderDate: "1996-07-25",
        requiredDate: "1996-08-22",
        shippedDate: "1996-08-12",
        shipVia: 1,
        freight: 55.28,
        shipName: "Blondel père et fils",
        shipAddress: "24 place Kléber",
        shipCity: "Strasbourg",
        shipRegion: "NULL",
        shipPostalCode: 67000,
        shipCountry: "France",
      },
      {
        orderID: 10266,
        customerID: "WARTH",
        employeeID: 3,
        orderDate: "1996-07-26",
        requiredDate: "1996-09-06",
        shippedDate: "1996-07-31",
        shipVia: 3,
        freight: 25.73,
        shipName: "Wartian Herkku",
        shipAddress: "Torikatu 38",
        shipCity: "Oulu",
        shipRegion: "NULL",
        shipPostalCode: 90110,
        shipCountry: "Finland",
      },
      {
        orderID: 10267,
        customerID: "FRANK",
        employeeID: 4,
        orderDate: "1996-07-29",
        requiredDate: "1996-08-26",
        shippedDate: "1996-08-06",
        shipVia: 1,
        freight: 208.58,
        shipName: "Frankenversand",
        shipAddress: "Berliner Platz 43",
        shipCity: "München",
        shipRegion: "NULL",
        shipPostalCode: 80805,
        shipCountry: "Germany",
      },
      {
        orderID: 10268,
        customerID: "GROSR",
        employeeID: 8,
        orderDate: "1996-07-30",
        requiredDate: "1996-08-27",
        shippedDate: "1996-08-02",
        shipVia: 3,
        freight: 66.29,
        shipName: "GROSELLA-Restaurante",
        shipAddress: "5ª Ave. Los Palos Grandes",
        shipCity: "Caracas",
        shipRegion: "DF",
        shipPostalCode: 1081,
        shipCountry: "Venezuela",
      },
      {
        orderID: 10269,
        customerID: "WHITC",
        employeeID: 5,
        orderDate: "1996-07-31",
        requiredDate: "1996-08-14",
        shippedDate: "1996-08-09",
        shipVia: 1,
        freight: 4.56,
        shipName: "White Clover Markets",
        shipAddress: "1029 - 12th Ave. S.",
        shipCity: "Seattle",
        shipRegion: "WA",
        shipPostalCode: 98124,
        shipCountry: "USA",
      },
    ],
  },

  {
    query: "select * from orders where shippedDate = '1996-07-23';",
    result: [
      {
        orderID: 10270,
        customerID: "WARTH",
        employeeID: 1,
        orderDate: "1996-08-01",
        requiredDate: "1996-08-29",
        shippedDate: "1996-08-02",
        shipVia: 1,
        freight: 136.54,
        shipName: "Wartian Herkku",
        shipAddress: "Torikatu 38",
        shipCity: "Oulu",
        shipRegion: "NULL",
        shipPostalCode: 90110,
        shipCountry: "Finland",
      },
      {
        orderID: 10271,
        customerID: "SPLIR",
        employeeID: 6,
        orderDate: "1996-08-01",
        requiredDate: "1996-08-29",
        shippedDate: "1996-08-30",
        shipVia: 2,
        freight: 4.54,
        shipName: "Split Rail Beer & Ale",
        shipAddress: "P.O. Box 555",
        shipCity: "Lander",
        shipRegion: "WY",
        shipPostalCode: 82520,
        shipCountry: "USA",
      },
      {
        orderID: 10272,
        customerID: "RATTC",
        employeeID: 6,
        orderDate: "1996-08-02",
        requiredDate: "1996-08-30",
        shippedDate: "1996-08-06",
        shipVia: 2,
        freight: 98.03,
        shipName: "Rattlesnake Canyon Grocery",
        shipAddress: "2817 Milton Dr.",
        shipCity: "Albuquerque",
        shipRegion: "NM",
        shipPostalCode: 87110,
        shipCountry: "USA",
      },
      {
        orderID: 10273,
        customerID: "QUICK",
        employeeID: 3,
        orderDate: "1996-08-05",
        requiredDate: "1996-09-02",
        shippedDate: "1996-08-12",
        shipVia: 3,
        freight: 76.07,
        shipName: "QUICK-Stop",
        shipAddress: "Taucherstraße 10",
        shipCity: "Cunewalde",
        shipRegion: "NULL",
        shipPostalCode: "01307",
        shipCountry: "Germany",
      },
    ],
  },

  {
    query: "select * from orders where orderID = 10248;",
    result: [
      {
        orderID: 10274,
        customerID: "VINET",
        employeeID: 6,
        orderDate: "1996-08-06",
        requiredDate: "1996-09-03",
        shippedDate: "1996-08-16",
        shipVia: 1,
        freight: 6.01,
        shipName: "Vins et alcools Chevalier",
        shipAddress: "59 rue de l'Abbaye",
        shipCity: "Reims",
        shipRegion: "NULL",
        shipPostalCode: 51100,
        shipCountry: "France",
      },
      {
        orderID: 10275,
        customerID: "MAGAA",
        employeeID: 1,
        orderDate: "1996-08-07",
        requiredDate: "1996-09-04",
        shippedDate: "1996-08-09",
        shipVia: 1,
        freight: 26.93,
        shipName: "Magazzini Alimentari Riuniti",
        shipAddress: "Via Ludovico il Moro 22",
        shipCity: "Bergamo",
        shipRegion: "NULL",
        shipPostalCode: 24100,
        shipCountry: "Italy",
      },
      {
        orderID: 10276,
        customerID: "TORTU",
        employeeID: 8,
        orderDate: "1996-08-08",
        requiredDate: "1996-08-22",
        shippedDate: "1996-08-14",
        shipVia: 3,
        freight: 13.84,
        shipName: "Tortuga Restaurante",
        shipAddress: "Avda. Azteca 123",
        shipCity: "México D.F.",
        shipRegion: "NULL",
        shipPostalCode: "05033",
        shipCountry: "Mexico",
      },
      {
        orderID: 10277,
        customerID: "MORGK",
        employeeID: 2,
        orderDate: "1996-08-09",
        requiredDate: "1996-09-06",
        shippedDate: "1996-08-13",
        shipVia: 3,
        freight: 125.77,
        shipName: "Morgenstern Gesundkost",
        shipAddress: "Heerstr. 22",
        shipCity: "Leipzig",
        shipRegion: "NULL",
        shipPostalCode: "04179",
        shipCountry: "Germany",
      },
    ],
  },
];

export const queries = [
  "select * from orders;",
  "select * from orders where freight > 40;",
  "select * from orders where employeeId = 3;",
  "select * from orders where orderedDate = '1996-07-10';",
  "select * from orders where shippedDate = '1996-07-23';",
  "select * from orders where orderID = 10248;",
];